import { ActorSubclass, HttpAgent } from '@icp-sdk/core/agent'
import {
  idlFactory as arbBridgeHelper,
  _SERVICE as ArbBridgeHelperActorType,
} from '../idls/arbBridgeHelper/arbBridgeHelper.did'
import { createActor } from '../utils/createActor'

export const ARB_BRIDGE_HELPER_CANISTER_ID = 'cxanv-7aaaa-aaaar-qbxpq-cai'
export const ARB_BRIDGE_HELPER_ETH_ADDRESS = '0x42a99913d4430ADb4c2e2A79E52C2fcE40e69FC4'

interface USDCBridgeProps {
  maxFeePerGas: bigint
  nonce: number
  gasLimit: bigint
  amount: bigint
  receiver: string
}

class ArbBridgeHelperClient {
  public agent: HttpAgent
  private helperActor: ActorSubclass<ArbBridgeHelperActorType>

  constructor(agent: HttpAgent) {
    this.agent = agent
    this.helperActor = createActor(arbBridgeHelper, {
      canisterId: ARB_BRIDGE_HELPER_CANISTER_ID,
      agent: this.agent,
    })
  }

  async bridgeUSDC({ maxFeePerGas, nonce, gasLimit, amount, receiver }: USDCBridgeProps) {
    const response = await this.helperActor.usdc_icp({
      max_fee_per_gas: maxFeePerGas,
      nonce: BigInt(nonce),
      gas_limit: gasLimit,
      amount,
      receiver,
    })

    if ('Err' in response) {
      if (response.Err === 'Nonce too low') return ''
      throw Error(`USDC Bridge error - ${response.Err}`)
    }

    if ('Ok' in response) {
      return response.Ok
    }
  }
}

export default ArbBridgeHelperClient
